import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const OrderNumber = styled.span`
    font-weight: 600;
    color: ${colors.primary};
`;

// Точка статуса оплаты: у оффлайновых способов оплаты её нет вовсе — деньги через нас
// не проходили, и «не оплачен» про них сказать нечего.
export const PaymentDot = styled.span<{ $tone: "paid" | "unpaid" | "refunded" }>`
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => {
        if (props.$tone === "paid") return colors.success;
        if (props.$tone === "refunded") return colors.danger;
        return colors.amber;
    }};
`;

export const Muted = styled.span`
    color: ${colors.textSecondary};
`;
